import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoicePortalRequestHdrContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_portal_request_hdr_container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiVisa, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';
import { MyEInvoicePortalAnonymousUserRequestContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_portal_anonymous_user_request_container.model';

@Injectable({
  providedIn: 'root'
})
export class MyEInvoicePortalRequestHdrService extends BaseApiPublicLoginTemplateService<MyEInvoicePortalRequestHdrContainerModel, MyEInvoicePortalRequestHdrContainerModel, MyEInvoicePortalRequestHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-hdrs/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-hdrs/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-hdrs/backoffice-ep'
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-hdrs/'+ BaseApiTemplateService.LOGIN_ENTITY_EP
    this.httpClient = http;
  }

  public getAnonymousUserRequest(
    pagination: Pagination,
    visa: ApiVisa,
    website_hdr_guid: string,
  ): Observable<PagingResponseModel<MyEInvoicePortalAnonymousUserRequestContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-hdrs/anonymous-user-query/website-ep/'
    const endpointUrl = visa.api_domain_url ?
      visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/request-hdrs/anonymous-user-query/website-ep/'
      : url;

    const UrlByCriteria = endpointUrl + website_hdr_guid + "?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MyEInvoicePortalAnonymousUserRequestContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
